import { render } from "./ExcludeDay-add.vue?vue&type=template&id=6cc842fc"
import script from "./ExcludeDay-add.vue?vue&type=script&lang=js"
export * from "./ExcludeDay-add.vue?vue&type=script&lang=js"

import "./ExcludeDay-add.vue?vue&type=style&index=0&id=6cc842fc&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__